import React from 'react';

import Search from '../../Framework/Components/Search';
import Text from '../../Framework/Components/Form/TextInput';
import TagCheckBoxFilter from '../../Framework/Components/Form/TagCheckBoxFilter';

const TagSearch = (props) => (
    <Search {...props}>
        <Text name="name" />

        <TagCheckBoxFilter name="types" />
    </Search>
);

export default TagSearch;
